const admy = {
  // ── SeoPage ──
  "admy.seo_keywords_ph": "Keyword1, Keyword2, Keyword3",

  // ── SocialPage placeholders ──
  "admy.eg_followers": "z.B. 12.4k",
  "admy.eg_posts": "z.B. 238",
  "admy.eg_likes": "z.B. 48.6k",
  "admy.eg_shortcode": "z.B. CxG7kPqLmN3",

  // ── TranslationsPage group names ──
  "admy.grp_nav": "Navigation",
  "admy.grp_hero": "Startseite Hero",
  "admy.grp_services": "Leistungen",
  "admy.grp_about": "Über uns",
  "admy.grp_pricing": "Preise",
  "admy.grp_booking": "Terminbuchung",
  "admy.grp_footer": "Footer",
  "admy.grp_gallery": "Galerie",
  "admy.grp_team": "Team",
  "admy.grp_clinic": "Klinik",
  "admy.grp_process": "Prozess",
  "admy.grp_trust": "Vertrauen",
  "admy.grp_dental": "Dental",
  "admy.grp_overview": "Übersicht",
  "admy.grp_implants": "Implantate",
  "admy.grp_contact": "Kontakt",
  "admy.grp_seo": "SEO",
  "admy.grp_admin": "Admin",
  "admy.grp_privacy": "Datenschutz",
  "admy.grp_imprint": "Impressum",
  "admy.grp_agb": "AGB",
  "admy.grp_language": "Sprachen",
  "admy.grp_service_detail": "Service Detail",
  "admy.grp_instagram": "Instagram",

  // ── PageEditorPage field labels (home) ──
  "admy.f_hero_line1": "Hero — Zeile 1",
  "admy.f_hero_line2": "Hero — Zeile 2",
  "admy.f_hero_subtitle": "Hero — Untertitel",
  "admy.f_hero_cta": "Hero — CTA Button",
  "admy.f_services_tag": "Services — Tag",
  "admy.f_services_heading": "Services — Überschrift",
  "admy.f_services_subtitle": "Services — Untertitel",
  "admy.f_hair_title": "Haartransplantation — Titel",
  "admy.f_hair_desc": "Haartransplantation — Beschreibung",
  "admy.f_dental_title": "Dental-Kosmetik — Titel",
  "admy.f_dental_desc": "Dental-Kosmetik — Beschreibung",
  "admy.f_botox_title": "Botox & Filler — Titel",
  "admy.f_botox_desc": "Botox & Filler — Beschreibung",
  "admy.f_services_cta": "Services — CTA Text",
  "admy.f_about_tag": "About — Tag",
  "admy.f_about_line1": "About — Zeile 1",
  "admy.f_about_line2": "About — Zeile 2",
  "admy.f_about_desc": "About — Beschreibung",
  "admy.f_about_cta": "About — CTA",
  "admy.f_pricing_tag": "Preise — Tag",
  "admy.f_pricing_line1": "Preise — Zeile 1",
  "admy.f_pricing_line2": "Preise — Zeile 2",
  "admy.f_pricing_subtitle": "Preise — Untertitel",
  "admy.f_pricing_cta": "Preise — CTA",
  "admy.f_testimonials_tag": "Bewertungen — Tag",
  "admy.f_testimonials_heading": "Bewertungen — Überschrift",
  "admy.f_testimonials_subtitle": "Bewertungen — Untertitel",
  "admy.f_testimonial1_text": "Bewertung 1 — Text",
  "admy.f_testimonial1_name": "Bewertung 1 — Name",
  "admy.f_testimonial1_role": "Bewertung 1 — Rolle",
  "admy.f_testimonial2_text": "Bewertung 2 — Text",
  "admy.f_testimonial2_name": "Bewertung 2 — Name",
  "admy.f_testimonial2_role": "Bewertung 2 — Rolle",
  "admy.f_testimonial3_text": "Bewertung 3 — Text",
  "admy.f_testimonial3_name": "Bewertung 3 — Name",
  "admy.f_testimonial3_role": "Bewertung 3 — Rolle",
  "admy.f_testimonial4_text": "Bewertung 4 — Text",
  "admy.f_testimonial4_name": "Bewertung 4 — Name",
  "admy.f_testimonial4_role": "Bewertung 4 — Rolle",
  "admy.f_testimonial5_text": "Bewertung 5 — Text",
  "admy.f_testimonial5_name": "Bewertung 5 — Name",
  "admy.f_testimonial5_role": "Bewertung 5 — Rolle",
  "admy.f_booking_tag": "Booking — Tag",
  "admy.f_booking_line1": "Booking — Zeile 1",
  "admy.f_booking_line2": "Booking — Zeile 2",
  "admy.f_booking_desc": "Booking — Beschreibung",
  "admy.f_booking_cta": "Booking — CTA",
  "admy.f_process_tag": "Prozess — Tag",
  "admy.f_process_heading": "Prozess — Überschrift",
  "admy.f_process_subtitle": "Prozess — Untertitel",
  "admy.f_trust_tag": "Vertrauen — Tag",
  "admy.f_trust_heading": "Vertrauen — Überschrift",
  "admy.f_trust_subtitle": "Vertrauen — Untertitel",
  "admy.f_instagram_heading": "Instagram — Überschrift",
  "admy.f_instagram_cta": "Instagram — CTA",
  "admy.f_footer_company": "Footer — Firmenname",
  "admy.f_footer_address": "Footer — Adresse",
  "admy.f_footer_phone": "Footer — Telefon",
  "admy.f_footer_email": "Footer — E-Mail",
  "admy.f_img_hero_bg": "Bild — Hero Hintergrund",
  "admy.f_img_hair": "Bild — Haartransplantation",
  "admy.f_img_dental": "Bild — Dental-Kosmetik",
  "admy.f_img_botox": "Bild — Botox & Filler",
  "admy.f_img_about_team": "Bild — Über uns Team",
  "admy.f_img_cta_bg": "Bild — CTA Hintergrund",
  "admy.f_img_process_bg": "Bild — Prozess Hintergrund",
  "admy.f_img_trust_bg": "Bild — Vertrauen Hintergrund",
  "admy.f_img_instagram_1": "Bild — Instagram 1",
  "admy.f_img_instagram_2": "Bild — Instagram 2",
  "admy.f_img_instagram_3": "Bild — Instagram 3",
  "admy.f_img_instagram_4": "Bild — Instagram 4",

  // ── shared / about ──
  "admy.f_tag": "Tag",
  "admy.f_headline_line1": "Headline Zeile 1",
  "admy.f_headline_line2": "Headline Zeile 2",
  "admy.f_description": "Beschreibung",
  "admy.f_quote": "Zitat",
  "admy.f_name": "Name",
  "admy.f_position": "Position",
  "admy.f_mission_title": "Mission — Titel",
  "admy.f_mission_text": "Mission — Text",
  "admy.f_values_title": "Werte — Titel",
  "admy.f_values_text": "Werte — Text",
  "admy.f_why_albania_title": "Warum Albanien — Titel",
  "admy.f_why_albania_text": "Warum Albanien — Text",
  "admy.f_cta_heading": "CTA — Überschrift",
  "admy.f_cta_subtitle": "CTA — Untertitel",
  "admy.f_cta_button": "CTA — Button",
  "admy.f_img_hero_bg_tirana": "Bild — Hero Hintergrund (Tirana)",
  "admy.f_img_doctor": "Bild — Team/Arzt Foto",
  "admy.f_img_mission": "Bild — Mission",
  "admy.f_img_clinic": "Bild — Klinik",

  // ── services ──
  "admy.f_headline": "Headline",
  "admy.f_subtitle": "Untertitel",
  "admy.f_hair_text": "Haartransplantation — Text",
  "admy.f_hair_price": "Haartransplantation — Preis",
  "admy.f_dental2_title": "Dental — Titel",
  "admy.f_dental2_text": "Dental — Text",
  "admy.f_dental2_price": "Dental — Preis",
  "admy.f_botox2_title": "Botox — Titel",
  "admy.f_botox2_text": "Botox — Text",
  "admy.f_botox2_price": "Botox — Preis",
  "admy.f_surgery_title": "Chirurgie — Titel",
  "admy.f_surgery_text": "Chirurgie — Text",
  "admy.f_surgery_price": "Chirurgie — Preis",
  "admy.f_cta_text": "CTA Text",
  "admy.f_cta_subtitle2": "CTA Untertitel",
  "admy.f_img_dental2": "Bild — Dental",
  "admy.f_img_botox2": "Bild — Botox",
  "admy.f_img_surgery": "Bild — Chirurgie",

  // ── pricing ──
  "admy.f_essential_title": "Essential — Titel",
  "admy.f_essential_price": "Essential — Preis",
  "admy.f_essential_desc": "Essential — Beschreibung",
  "admy.f_essential_features": "Essential — Features (kommagetrennt)",
  "admy.f_premium_title": "Premium — Titel",
  "admy.f_premium_price": "Premium — Preis",
  "admy.f_premium_desc": "Premium — Beschreibung",
  "admy.f_premium_features": "Premium — Features (kommagetrennt)",
  "admy.f_luxe_title": "Luxe — Titel",
  "admy.f_luxe_price": "Luxe — Preis",
  "admy.f_luxe_desc": "Luxe — Beschreibung",
  "admy.f_luxe_features": "Luxe — Features (kommagetrennt)",
  "admy.f_exclusif_title": "Exclusif — Titel",
  "admy.f_exclusif_price": "Exclusif — Preis",
  "admy.f_exclusif_desc": "Exclusif — Beschreibung",
  "admy.f_exclusif_features": "Exclusif — Features (kommagetrennt)",
  "admy.f_guarantee_text": "Garantie-Text",
  "admy.f_img_essential": "Bild — Essential Paket",
  "admy.f_img_premium": "Bild — Premium Paket",
  "admy.f_img_luxe": "Bild — Luxe Paket",
  "admy.f_img_exclusif": "Bild — Exclusif Paket",

  // ── booking ──
  "admy.f_hero_subtitle2": "Hero Untertitel",
  "admy.f_form_title": "Formular — Titel",
  "admy.f_form_subtitle": "Formular — Untertitel",
  "admy.f_form_firstname": "Formular — Vorname Label",
  "admy.f_form_lastname": "Formular — Nachname Label",
  "admy.f_form_email": "Formular — E-Mail Label",
  "admy.f_form_phone": "Formular — Telefon Label",
  "admy.f_form_service": "Formular — Behandlung Label",
  "admy.f_form_message": "Formular — Nachricht Label",
  "admy.f_form_privacy": "Formular — Datenschutz Text",
  "admy.f_success_title": "Erfolg — Titel",
  "admy.f_success_message": "Erfolg — Nachricht",
  "admy.f_contact_tag": "Kontakt — Tag",
  "admy.f_contact_heading": "Kontakt — Überschrift",
  "admy.f_contact_subtitle": "Kontakt — Untertitel",

  // ── team ──
  "admy.f_cta_headline": "CTA Headline",
  "admy.f_cta_subtitle3": "CTA Subtitle",
  "admy.f_cta_button2": "CTA Button",
  "admy.f_show_more": "Mehr anzeigen",
  "admy.f_show_less": "Weniger anzeigen",

  // ── gallery ──
  "admy.f_filter_all": "Filter — Alle",
  "admy.f_filter_dental": "Filter — Dental",
  "admy.f_filter_surgery": "Filter — Chirurgie",
  "admy.f_filter_hair": "Filter — Haar",
  "admy.f_filter_aesthetic": "Filter — Ästhetik",
  "admy.f_before_label": "Vorher-Label",
  "admy.f_after_label": "Nachher-Label",
};

export default admy;
